import { render, staticRenderFns } from "./SubmitForReviewButton.vue?vue&type=template&id=526d33ac&scoped=true&"
import script from "./SubmitForReviewButton.vue?vue&type=script&lang=js&"
export * from "./SubmitForReviewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d33ac",
  null
  
)

export default component.exports